module.exports = __webpack_public_path__ + "assets/payment-card.e1e353aa.svg";